import { Subscription } from "../../services/api";
import { TrackingIntegrations } from "../../services/api/models";
import { createStrictContext } from "../utils";

export interface AppState {
  editingSiteId?: string;
  editingSiteModified: boolean;
  editingSiteSubscription: Subscription;
  published: boolean;
  editingSiteDisabled: boolean;
  notRedirectOnEmptySites: boolean;
  isPROUser: boolean;
  editingSiteTrackingIntegrations?: TrackingIntegrations;
  /** Keepo com senha is on for the Keepo being edited */
  editingSitePasswordProtected?: boolean;
  editingSiteAgeGated?: boolean;
  customDomainSettings?: any;
}

export type AppStateContextType = {
  appState: AppState;
  setAppState: (site: AppState) => void;
  markAuthenticated: () => Promise<void>;
};

export const [AppContextProvider, useAppState] = createStrictContext<AppStateContextType>();

export const defaultAppState: AppState = {
  editingSiteSubscription: { type: "FREE" },
  editingSiteModified: false,
  published: false,
  editingSiteDisabled: false,
  notRedirectOnEmptySites: false,
  isPROUser: false,
  customDomainSettings: undefined,
};
